import { action as apiAction } from 'api/Api'

type Payload = {
  userId: number
  userGroupId: number
}

export default (payload: Payload) => async () => {
  const { userId, userGroupId } = payload

  try {
    await apiAction('AddUserToGroup', {
      userId,
      groupId: userGroupId
    })
  } catch (error) {
    if (error.code !== 300) { // Duplicate
      throw error
    }
  }
}

